"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Executor = void 0;
var messageListeners_1 = require("./messageListeners");
var results_1 = require("./results");
var context_1 = require("./context");
var Executor = /** @class */ (function () {
    function Executor(library, codeService, parameters, messageListener) {
        if (messageListener === void 0) { messageListener = new messageListeners_1.NullMessageListener(); }
        this.library = library;
        this.codeService = codeService;
        this.parameters = parameters;
        this.messageListener = messageListener;
    }
    Executor.prototype.withLibrary = function (lib) {
        this.library = lib;
        return this;
    };
    Executor.prototype.withParameters = function (params) {
        this.parameters = params != null ? params : {};
        return this;
    };
    Executor.prototype.withCodeService = function (cs) {
        this.codeService = cs;
        return this;
    };
    Executor.prototype.withMessageListener = function (ml) {
        this.messageListener = ml;
        return this;
    };
    Executor.prototype.exec_expression = function (expression, patientSource, executionDateTime) {
        var _a;
        var r = new results_1.Results();
        var expr = this.library.expressions[expression];
        if (expr != null) {
            while (patientSource.currentPatient()) {
                var patient_ctx = new context_1.PatientContext(this.library, patientSource.currentPatient(), this.codeService, this.parameters, executionDateTime, this.messageListener);
                r.recordPatientResults(patient_ctx, (_a = {}, _a[expression] = expr.execute(patient_ctx), _a));
                patientSource.nextPatient();
            }
        }
        return r;
    };
    Executor.prototype.exec = function (patientSource, executionDateTime) {
        var r = this.exec_patient_context(patientSource, executionDateTime);
        var unfilteredContext = new context_1.UnfilteredContext(this.library, r, this.codeService, this.parameters, executionDateTime, this.messageListener);
        var resultMap = {};
        for (var key in this.library.expressions) {
            var expr = this.library.expressions[key];
            if (expr.context === 'Unfiltered') {
                resultMap[key] = expr.exec(unfilteredContext);
            }
        }
        r.recordUnfilteredResults(resultMap);
        return r;
    };
    Executor.prototype.exec_patient_context = function (patientSource, executionDateTime) {
        var r = new results_1.Results();
        while (patientSource.currentPatient()) {
            var patient_ctx = new context_1.PatientContext(this.library, patientSource.currentPatient(), this.codeService, this.parameters, executionDateTime, this.messageListener);
            var resultMap = {};
            for (var key in this.library.expressions) {
                var expr = this.library.expressions[key];
                if (expr.context === 'Patient') {
                    resultMap[key] = expr.execute(patient_ctx);
                }
            }
            r.recordPatientResults(patient_ctx, resultMap);
            patientSource.nextPatient();
        }
        return r;
    };
    return Executor;
}());
exports.Executor = Executor;
//# sourceMappingURL=executor.js.map